import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { StaffBasic } from 'src/app/models/helpbutton-models/helpbutton-staff-basic.model';
import { DepartmentGroup } from 'src/app/models/helpbutton-models/helpbutton-department-group.model';
import { DepartmentsHelpbuttonService } from 'src/app/services/helpbutton-services/departments-helpbutton-service/departments-helpbutton.service';
import { Subscription } from 'rxjs';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';

@Component({
  selector: 'app-helpbutton-department-groups-card',
  templateUrl: './helpbutton-department-groups-card.component.html',
  styleUrls: ['./helpbutton-department-groups-card.component.scss']
})
export class HelpbuttonDepartmentGroupsCardComponent implements OnInit, OnDestroy {

  @Input() groups: Array<DepartmentGroup>;
  @Input() staffs: Array<StaffBasic>;
  saveGroupSecondsSubscription: Subscription;
  saveStaffGroupRelationSubscription: Subscription;
  removeStaffAndGroupRelationSubscription: Subscription;

  constructor(private departmentsService: DepartmentsHelpbuttonService,
    private snackbarService: SnackBarService) { }

  ngOnInit() { }

  public addEventReceiver(event, group) {
    for (const staff of event.addedItems) {
      this.saveStaffGroupRelation(group, staff);
    }
  }

  public removeEventReceiver(event, group) {
    for (const staff of event.removedItems) {
      this.removeStaffAndGroupRelation(group, staff);
    }
  }

  public saveStaffGroupRelation(group, staff) {
    this.saveStaffGroupRelationSubscription = this.departmentsService.saveStaffGroupRelation(group.InternalId, staff.InternalId).subscribe(
      (res) => {
        if (!res['data']['success']) {
          this.snackbarService.open('helpbutton-page.snackbar messages.save staff group relation error', 'error');
        }
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public removeStaffAndGroupRelation(group, staff) {
    this.removeStaffAndGroupRelationSubscription = this.departmentsService.removeStaffAndGroupRelation(group.InternalId, staff.InternalId).subscribe(
      (res) => {
        if (!res['data']['success']) {
          this.snackbarService.open('helpbutton-page.snackbar messages.remove staff group relation error', 'error');
        }
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public saveGroupSeconds(group) {
    if (group.SecondsBeforeNextWave >= 0) {
      this.saveGroupSecondsSubscription = this.departmentsService.saveGroupSeconds(group.InternalId, group.SecondsBeforeNextWave).subscribe(
        (res) => {
          if (!res['data']['success']) {
            this.snackbarService.open('helpbutton-page.snackbar messages.change seconds error', 'error');
          }
        },
        (error) => {
          this.snackbarService.open(error['error']['message'], 'error');
        }
      );
    } else {
      group.SecondsBeforeNextWave = 0;
      this.snackbarService.open('helpbutton-page.snackbar messages.change seconds error', 'error');
    }
  }

  public increaseSeconds(group) {
    group.secondsBeforeNextWave++;
    this.saveGroupSeconds(group);
  }

  public decreaseSeconds(group) {
    if (group.secondsBeforeNextWave >= 0) {
      group.secondsBeforeNextWave--;
      this.saveGroupSeconds(group);
    }
  }

  ngOnDestroy() {
    if (this.saveGroupSecondsSubscription) { this.saveGroupSecondsSubscription.unsubscribe(); }
    if (this.saveStaffGroupRelationSubscription) { this.saveStaffGroupRelationSubscription.unsubscribe(); }
    if (this.removeStaffAndGroupRelationSubscription) { this.removeStaffAndGroupRelationSubscription.unsubscribe(); }
  }

}
